import { createSelector } from '@reduxjs/toolkit';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';

const communicatorMessageProjections = {} as ObjectOfAny;

communicatorMessageProjections.communicatorMessageList = createSelector(
    (state: RootState) => state.communicatorMessage.communicatorMessage,
    communicatorMessage => {
        if (!communicatorMessage) {
            return [];
        }

        return communicatorMessage.map(
            (message: {
                items: any;
                user: { fullName: string };
                visibleToAragOnly: string;
            }) => {
                if (message.items && Object.values(message.items).length > 1) {
                    let fieldsWithText: any[] = [];
                    let fieldsWithAttachments: any[] = [];
                    return message.items.reduce(
                        (
                            obj: any,
                            cur: {
                                fields: string[];
                                typeName: string;
                                id: string;
                                timestamp: any;
                                type: number;
                                entityId: string;
                            },
                        ) => {
                            let previousTypeName = '';
                            let typeName = message.items.find(
                                (i: { typeName: string }) => i.typeName,
                            )?.typeName;
                            if (cur.fields && cur.fields.length > 0) {
                                cur.fields.forEach(field => {
                                    let fileContent =
                                        GENERAL_FUNCTIONS.findAttachmentsToMessageCommunicator(
                                            field,
                                        );
                                    if (
                                        fileContent &&
                                        Object.values(fileContent).length > 2
                                    ) {
                                        fieldsWithAttachments.push({
                                            name: fileContent.filename,
                                            id: fileContent.id,
                                        });
                                    } else {
                                        if (cur.typeName !== previousTypeName) {
                                            let multipleLog =
                                                '\xa0'.repeat(5) +
                                                `<div style={{display:"flex",flexDirection:"column"}}><b>${cur?.typeName.replace(/<[^>]*>?/gm, '')}</b></div>` +
                                                field;
                                            fieldsWithText.push(multipleLog);
                                            previousTypeName = cur.typeName;
                                        } else {
                                            fieldsWithText.push(field);
                                        }
                                    }
                                });
                            }
                            return {
                                ...obj,
                                id: cur.id,
                                createdDate: GENERAL_FUNCTIONS.dateFormat(
                                    cur.timestamp,
                                ),
                                createdBy: message.user.fullName,
                                title: typeName.replace(/<[^>]*>?/gm, ''),
                                type: cur.type,
                                log: fieldsWithText,
                                attachments:
                                    fieldsWithAttachments &&
                                    fieldsWithAttachments.length > 0
                                        ? fieldsWithAttachments
                                        : null,
                                messageId: cur.entityId,
                                visibleToAragOnly: message.visibleToAragOnly,
                            };
                        },
                        {},
                    );
                } else {
                    return message.items.reduce(
                        (
                            obj: any,
                            cur: {
                                fields: string[];
                                typeName: string;
                                id: string;
                                timestamp: any;
                                type: number;
                                entityId: string;
                            },
                        ) => {
                            let fieldsWithText: any[] = [];
                            let fieldsWithAttachments: any[] = [];

                            if (
                                cur.type === 15 ||
                                cur.type === 14 ||
                                cur.type === 13
                            ) {
                                let templateObject = {
                                    fileName: null,
                                    fileId: null,
                                    name: null,
                                };
                                if (cur.fields && cur.fields.length > 0) {
                                    cur.fields.forEach(field => {
                                        let fileContent =
                                            GENERAL_FUNCTIONS.findAttachmentsToMessageCommunicator(
                                                field,
                                            );
                                        let stringContent =
                                            GENERAL_FUNCTIONS.findTableContent(
                                                field,
                                            );
                                        templateObject = Object.assign(
                                            templateObject,
                                            { templateContent: stringContent },
                                        );
                                        if (
                                            fileContent &&
                                            Object.values(fileContent).length >
                                                0
                                        ) {
                                            return (templateObject = {
                                                ...templateObject,
                                                name: fileContent.filename,
                                                fileName: fileContent.filename,
                                                fileId: fileContent.id,
                                            });
                                        }
                                    });
                                }
                                return {
                                    ...obj,
                                    id: cur.id,
                                    createdDate: GENERAL_FUNCTIONS.dateFormat(
                                        cur.timestamp,
                                    ),
                                    createdBy: message.user.fullName,
                                    title: cur?.typeName.replace(
                                        /<[^>]*>?/gm,
                                        '',
                                    ),
                                    log: templateObject,
                                    type: cur.type,
                                    messageId: cur.entityId,
                                };
                            }
                            if (cur.fields && cur.fields.length > 0) {
                                cur.fields.forEach(field => {
                                    let fileContent =
                                        GENERAL_FUNCTIONS.findAttachmentsToMessageCommunicator(
                                            field,
                                        );
                                    if (
                                        fileContent &&
                                        Object.values(fileContent).length > 0
                                    ) {
                                        fieldsWithAttachments.push({
                                            name: fileContent.filename,
                                            id: fileContent.id,
                                        });
                                    } else {
                                        fieldsWithText.push(field);
                                    }
                                });
                            }
                            return {
                                ...obj,
                                id: cur.id,
                                createdDate: GENERAL_FUNCTIONS.dateFormat(
                                    cur.timestamp,
                                ),
                                createdBy: message.user.fullName,
                                title: cur?.typeName.replace(/<[^>]*>?/gm, ''),
                                type: cur.type,
                                log: fieldsWithText,
                                attachments:
                                    fieldsWithAttachments &&
                                    fieldsWithAttachments.length > 0
                                        ? fieldsWithAttachments
                                        : null,
                                messageId: cur.entityId,
                            };
                        },
                        {},
                    );
                }
            },
        );
    },
);

export default communicatorMessageProjections;
